import { Input, Label } from "reactstrap";
import { CommonSwitchSpanProp } from "../../../../Type/FormWidgets";

const CommonSwitchSpan = ({ color,defaultChecked }: CommonSwitchSpanProp) => {
  return (
    <Label className="switch mb-0">
      <Input type="checkbox" defaultChecked={defaultChecked} />
      <span className={`switch-state bg-${color}`}></span>
    </Label>
  );
};

export default CommonSwitchSpan;
